import { useMemo } from 'react'
import { Link, useOutletContext } from 'react-router'
import { PhotosetFinal } from '@/features/photoset/components/photoset-final'
import { qaStepIdToStepSlug } from '@/features/photoset/hooks/use-redirect-qa-photoset'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { Photoset, PhotosetURLParams } from '@/features/photoset/types'
import { Trans, useTranslation } from '@/translations/i18n'

const stepKeyToLabel = {
	5: 'photoset:editingQaSelection.title',
	6: 'photoset:editingQaFlags.title',
	14: 'photoset:vetting_qa.title',
	11: 'photoset:retouching_qa.title'
} as const satisfies Partial<
	Record<NonNullable<Photoset['qa_step_id']>, string>
>

export const PhotosetUnavailable2La = () => {
	const { t } = useTranslation()
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const { data: photoset, isFetching } = useGetPhotoset(urlParams, {
		enabled: false
	})

	const currentQaStep = useMemo(
		() =>
			photoset?.qa_step_id
				? {
						slug: qaStepIdToStepSlug?.[
							photoset.qa_step_id as keyof typeof qaStepIdToStepSlug
						],
						label: stepKeyToLabel?.[
							photoset.qa_step_id as keyof typeof stepKeyToLabel
						]
					}
				: null,
		[photoset?.qa_step_id]
	)

	return (
		<PhotosetFinal
			isLoading={isFetching}
			status='error'
			subtitle={
				currentQaStep && photoset?.id ? (
					<Trans
						components={{
							a: (
								<Link
									className='cursor-pointer text-neutral-900 underline underline-offset-4'
									to={`/photoset/${photoset.id}/2la/${currentQaStep.slug}`}
								/>
							)
						}}
						i18nKey='photoset:unavailable_2la.subtitle'
						values={{ label: t(currentQaStep.label) }}
					/>
				) : (
					t('common:unknown')
				)
			}
			title={t('photoset:unavailable_2la.title')}
		/>
	)
}
